/* eslint-disable css-modules/no-undef-class */
import { motion } from 'framer-motion';
import InspirationalSearchFlowFooter from '../inspirational-search-flow-footer/inspirational-search-flow-footer';
import InspirationalSearchFlowQuestion, {
  InspirationalSearchFlowQuestionProps,
} from '../inspirational-search-flow-question/inspirational-search-flow-question';
import InspirationalSearchFlowStepIndicator from '../inspirational-search-flow-step-indicator/inspirational-search-flow-step-indicator';
import styles from './inspirational-search-flow-step.module.scss';

export interface InspirationalSearchFlowStepProps {
  /** The currently active step */
  currentStep?: number;
  /** An event that is triggered on change */
  onChange?: (value: number[][]) => void;
  /** An event that is triggered when clicking the next button */
  onClickNext?: () => void;
  /** An event that is triggered when clicking the previous button */
  onClickPrevious?: () => void;
  /** An event that is triggered when clicking the result link */
  onClickResult?: () => void;
  /** The list of questions to show */
  questions: InspirationalSearchFlowQuestionProps[];
  /** The url of the result page */
  resultPageUrl?: string;
  /** The total amount of steps */
  stepCount?: number;
  /** The value of the step */
  value?: number[][];
}

const InspirationalSearchFlowStep = ({
  currentStep = 1,
  onChange,
  onClickNext,
  onClickPrevious,
  onClickResult,
  questions = [],
  resultPageUrl,
  stepCount = 0,
  value = [],
}: InspirationalSearchFlowStepProps) => {
  return (
    <div className={styles.component}>
      <motion.div
        animate="show"
        className={styles.content}
        exit="hidden"
        initial="hidden"
        variants={{
          hidden: { opacity: 0, translateY: 20 },
          show: {
            opacity: 1,
            transition: {
              duration: 0.25,
            },
            translateY: 0,
          },
        }}
      >
        <InspirationalSearchFlowStepIndicator
          currentStep={currentStep}
          stepCount={stepCount}
        />

        {questions.length > 0 && (
          <div className={styles.questions}>
            {questions.map((question, questionIndex) => (
              <InspirationalSearchFlowQuestion
                key={questionIndex}
                {...question}
                onChange={array => {
                  onChange?.(
                    value.map((item, itemIndex) =>
                      itemIndex === questionIndex ? array : item,
                    ),
                  );
                }}
                value={value[questionIndex]}
              />
            ))}
          </div>
        )}
      </motion.div>

      <motion.div
        animate="show"
        className={styles.footer}
        exit="hidden"
        initial="hidden"
        variants={{
          hidden: { opacity: 0 },
          show: {
            opacity: 1,
            transition: {
              duration: 0.25,
            },
          },
        }}
      >
        <InspirationalSearchFlowFooter
          currentStep={currentStep}
          disableNext={value.some(
            questionSelection => !questionSelection.length,
          )}
          onClickNext={onClickNext}
          onClickPrevious={onClickPrevious}
          onClickResult={onClickResult}
          resultPageUrl={resultPageUrl}
          stepCount={stepCount}
        />
      </motion.div>
    </div>
  );
};

InspirationalSearchFlowStep.displayName = 'InspirationalSearchFlowStep';

export default InspirationalSearchFlowStep;
